import {
	createFileRoute,
	Outlet,
	useParams,
	useRouterState,
} from "@tanstack/react-router";
import { AssetWorkspaceRecordsTable } from "@/features/assets/components/asset-workspace-records-table";
import { isNestedRecordUnderAssetWorkspacePath } from "@/features/jobs/lib/is-nested-asset-workspace-path.util";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/assets/$assetId/workspace/records",
)({
	component: AssetWorkspaceRecordsTab,
	validateSearch: (search: Record<string, unknown>) => ({
		q: typeof search.q === "string" ? search.q : undefined,
	}),
});

/**
 * Asset workspace Records tab — table shell with outlet for record drawer / nested workspace.
 */
function AssetWorkspaceRecordsTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/assets/$assetId/workspace/records",
	});
	const pathname = useRouterState({
		select: (state) => state.location.pathname,
	});

	if (isNestedRecordUnderAssetWorkspacePath(pathname)) {
		return <Outlet />;
	}

	return (
		<div className="relative flex min-h-0 w-full flex-1 flex-col">
			<AssetWorkspaceRecordsTable
				orgId={params.orgId}
				jobId={params.jobId}
				assetId={params.assetId}
			/>
			<Outlet />
		</div>
	);
}
